<template>
  <div
    id="container-externo"
    :class="[{
      'sem-menu': estaEmRotasSemMenu,
      'fundo-home': estaNaHome,
      'resultado-aberto': painelAberto,
      'resultado-estreito': painelAberto && janelaEstreita,
      'resultado-em-foco': painelAberto && janelaEstreita && vistaEstreita === 'resultado',
      'com-barra-aviso-usuario-suporte': exibirBarraAvisoUsuarioSuporte,
      'com-barra-transicao': exibirBarraTransicao
    }, classeDoAssistente]"
    :style="estiloDaGrade"
  >
    <BarraAvisoUsuarioSuporte
      v-if="exibirBarraAvisoUsuarioSuporte"
      :ambiente="dadosBarraAvisoUsuarioSuporte.ambiente"
      :empresa="dadosBarraAvisoUsuarioSuporte.empresa"
      @fechar="fecharBarraAvisoUsuarioSuporte"
    />
    <BarraTransicaoDeEscalas
      v-if="exibirBarraTransicao"
      :inert="painelAberto"
      @altura="alturaBarraTransicao = $event"
    />
    <MenuLateral id="menu-lateral" :inert="painelAberto" :oculto="oculto" :secao-acoes-complementares="ajudaDoMenu" v-if="userInfo && !estaEmRotasSemMenu"/>
    <div id="conteudo-aplicacao" :inert="painelAberto" :class="{ 'conteudo-aplicacao--full': estaEmRotasSemMenu || usaLarguraUtilCompleta }">
      <!--
        R6 — a chave só muda quando o Assistente avisa que a tela aberta ficou
        velha; navegar não a toca. É isso que separa esta remontagem pontual do
        `:key="$route.fullPath"` da receita comum, que remontaria a cada passo
        entre rotas que compartilham componente.
      -->
      <router-view class="view" :key="revalidacaoDaView" />
      <BarraDePreenchimento
        v-if="preenchimentoDaTela || falhaDePreenchimento"
        :resultado="preenchimentoDaTela"
        :falha="falhaDePreenchimento"
        @manter="manterPreenchimentoDaTela"
        @limpar="limparPreenchimentoDaTela"
        @dispensar="dispensarPreenchimentoDaTela"
      />
    </div>
    <button
      v-if="painelAberto"
      type="button"
      class="resultado-contexto__fundo"
      :aria-label="$t('assistentePontotel.acoes.voltarATela')"
      data-assistente-ignorar
      @click="voltarATela"
      @wheel.prevent
    />
    <AssistenteDock
      :conversa-em-abas="painelAberto && janelaEstreita"
      :conversa-oculta="painelAberto && janelaEstreita && vistaEstreita === 'resultado'"
      v-if="deveMontarOAssistente"
      :montado="deveMontarOAssistente"
      :messages="assistente.messages"
      :resultados-por-id="assistente.resultadosPorId"
      :resultado-ativo-id="assistente.resultadoAtivoId"
      :resultado-visivel="painelAberto"
      :context="contextoDoAssistente"
      :loading="assistente.loading"
      :largura-da-janela="larguraDaJanela"
      :intencao="intencaoDoAssistente"
      :leitura-da-tela-autorizada="assistente.leituraDaTelaAutorizada"
      :opcoes-avancadas="assistente.opcoesAvancadas"
      @send="enviarMensagemDoDock"
      @update:intencao="atualizarIntencaoDoAssistente"
      @nova-conversa="pedirNovaConversa"
      @preview="gerarPrevia"
      @abrir-resultado="abrirResultadoDeTurno"
      @abrir-navegacao="abrirNavegacaoDaMensagem"
      @history="abrirHistorico"
      @politicas="abrirPoliticasDeIa"
      @aceitar-oferta-de-suporte="aceitarOfertaDeSuporte"
      @selecionar-opcao="responderSelecaoDaAntecipacao"
      @responder-solicitacao-de-parametros="responderSolicitacaoDeParametros"
      @avaliar-resposta="avaliarResposta"
      @executar-planejamento="executarPlanejamento"
      @update:modo-de-acao="definirModoDeAcao"
    >
      <template #abas>
        <div
          v-if="painelAberto && janelaEstreita"
          class="resultado-contexto__abas"
          role="tablist"
          :aria-label="$t('assistentePontotel.painelNoContexto.alternar')"
          data-assistente-ignorar
          @keydown.left.prevent="alternarAbaPeloTeclado"
          @keydown.right.prevent="alternarAbaPeloTeclado"
        >
          <button
            type="button"
            role="tab"
            id="aba-conversa"
            aria-controls="resultado-conversa"
            :tabindex="vistaEstreita === 'conversa' ? 0 : -1"
            :aria-selected="vistaEstreita === 'conversa'"
            @click="escolherVistaEstreita('conversa')"
          >{{ $t('assistentePontotel.painelNoContexto.conversa') }}</button>
          <button
            type="button"
            role="tab"
            id="aba-resultado"
            aria-controls="resultado-painel"
            :tabindex="vistaEstreita === 'resultado' ? 0 : -1"
            :aria-selected="vistaEstreita === 'resultado'"
            @click="escolherVistaEstreita('resultado')"
          >{{ $t('assistentePontotel.painelNoContexto.resultado') }}</button>
        </div>
      </template>
    </AssistenteDock>
    <section
      v-if="painelPresente"
      v-show="painelAberto && (!janelaEstreita || vistaEstreita === 'resultado')"
      ref="painelDoResultado"
      id="resultado-painel"
      :role="janelaEstreita ? 'tabpanel' : undefined"
      :aria-labelledby="janelaEstreita ? 'aba-resultado' : undefined"
      class="resultado-contexto"
      tabindex="-1"
      :aria-label="$t('assistentePontotel.painelNoContexto.resultado')"
      data-assistente-ignorar
    >
      <CanvasPane
        :canvas="assistente.canvas"
        :interacao-id="assistente.resultadoAtivoId"
        :loading="assistente.loading"
        :historico-no-host="true"
        :voltar-para-tela="true"
        @close="voltarATela"
        @preview="gerarPrevia"
        @alteracao-formulario="atualizarRascunhoDoFormulario"
        @confirm="confirmarPrevia"
        @destructive="prosseguirDestrutiva"
        @refresh="refazerPrevia"
        @reconcile="reconciliar"
        @sugestao-escolhida="enviarMensagemDoDock"
        @nova-conversa="pedirNovaConversa"
      />
    </section>
    <p class="resultado-contexto__anuncio" aria-live="polite" data-assistente-ignorar>
      {{ anuncioDoResultado }}
    </p>
    <!--
      A gaveta vive no host, não dentro do dock: ela é teleportada para o body
      e cobre o app inteiro. Antes disso, "↺ Histórico" no dock ligava o estado
      e nada observava — só a página cheia montava a gaveta.
    -->
    <HistoryDrawer
      v-if="deveMontarOAssistente"
      :open="historicoAberto"
      :items="historicoDeConversas"
      :autor="contextoDoAssistente.displayName"
      @close="fecharHistorico"
      @reopen="reabrirHistorico"
    />
    <ConfirmacaoDeNovaConversa
      v-if="deveMontarOAssistente"
      :aberto="confirmacaoDeNovaConversa"
      :quantidade-de-mensagens="assistente.messages.length"
      @cancelar="cancelarNovaConversa"
      @confirmar="confirmarNovaConversa"
    />
    <!-- Container global de toasts — montado uma vez; renderiza via Teleport em <body> -->
    <PToaster />
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import BarraAvisoUsuarioSuporte from "@/common/BarraAvisoUsuarioSuporte/BarraAvisoUsuarioSuporte.vue";
import BarraTransicaoDeEscalas from "@/common/BarraTransicaoDeEscalas/BarraTransicaoDeEscalas.vue";
import {
  obterDadosBarraAviso,
  obterEstadoFechadoNoStorage,
  salvarEstadoFechadoNoStorage
} from "@/common/BarraAvisoUsuarioSuporte/logicaBarraAvisoUsuarioSuporte";
import MenuLateral from "@/common/MenuLateral/MenuLateral.vue";
import AssistenteDock from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/acoplamento/AssistenteDock.vue";
import { papelDoUsuario } from "@/typescript/modulos/governanca/AssistentePontotel/dominio/capacidades";
import { chaveDoNomeDaTela } from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/nomeDeTela";
import { telaAbertaFicouVelha } from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/invalidacaoDeTela";
import { decidirRevalidacaoDaTelaAberta } from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/revalidacaoDaTelaAberta";
import { capturarContextoDeAbertura, identidadeDaAberturaCompativel, processarContextoDeAbertura } from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/navegacaoDeTela";
import { aplicarQuandoRenderizar, consumirContextoDeAbertura, limparPreenchimento, manterPreenchimento } from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/preenchimentoDeTela";
import {
  LARGURA_DA_COLUNA_DO_ASSISTENTE,
  LARGURA_MINIMA_COM_RESULTADO,
  lerIntencaoDoAcoplamento,
  persistirIntencaoDoAcoplamento,
  proximaIntencao,
  formaDoAcoplamento,
  deveMontarOAssistente
} from "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/acoplamento/acoplamentoDoAssistente";
import { criarSecaoAjuda } from '@/common/MenuLateral/ajudaDoMenu'
import { abrirChatCrisp, deveInicializarCrisp, sincronizarApresentacaoCrisp } from '@/typescript/servicos/crisp/apresentacaoDoCrisp'
import { encaminharAoSuporte, encaminharSaindoDoAssistente } from '@/typescript/servicos/crisp/encaminhamentoAoSuporte'
import { ServicoToast } from '@/common/toast/ServicoToast'
import PToaster from "@/common/toast/PToaster.vue";
import { registrarDespachanteDeAcoesDosModulos } from '@/typescript/modulos/governanca/AssistentePontotel/apresentacao/ponteDeAcoesDosModulos'
import {
  resolverAlvoDaFolhaAtual,
  rotasEquivalentesDaFolhaAtual
} from '@/components/Sheets/Timesheet/obterPeriodoAtualDaFolha'
import { mapState } from "vuex";
import {
  construirContextoDoShell,
  deveSuprimirChromeDoShell,
} from "@/typescript/servicos/shell/rotasSemMenu";

export default {
  name: "App",
  data() {
    return {
      abrindoSuporte: false,
      oculto: false,
      fechadaManualmente: false,
      alturaBarraTransicao: 0,
      larguraDaJanela: typeof window === "undefined" ? 0 : window.innerWidth,
      alturaVisual: typeof window === "undefined" ? 0 : window.innerHeight,
      topoVisual: 0,
      intencaoDoAssistente: lerIntencaoDoAcoplamento(),
      assistenteIniciado: false,
      confirmacaoDeNovaConversa: false,
      // R6 — contador de revalidação da tela hospedada. Só sobe quando uma
      // mutação do Assistente envelhece a tela que a pessoa está vendo; subir
      // remonta o componente da rota, que volta a buscar os dados.
      revalidacaoDaView: 0,
      // Elemento que tinha o foco quando a gaveta abriu. Não é estado de UI:
      // não entra em render nenhum, só serve para devolver o foco ao fechar.
      origemDoHistorico: null,
      origemDoResultado: null,
      vistaEstreita: "resultado",
      anuncioDoResultado: "",
      preenchimentoDaTela: null,
      falhaDePreenchimento: null,
      aberturaEmCurso: 0,
      limparDespachanteDeAcoesDosModulos: null,
    };
  },
  async created() {
    // eslint-disable-next-line no-console
    console.log(
      "Versão:",
      process?.env?.VUE_APP_TAG_VERSION ? process.env.VUE_APP_TAG_VERSION : "-"
    );
    this.verificarLarguraTela();
    window.addEventListener("resize", this.verificarLarguraTela);
    this.atualizarAreaVisual();
    window.visualViewport?.addEventListener("resize", this.atualizarAreaVisual);
    window.visualViewport?.addEventListener("scroll", this.atualizarAreaVisual);
    this.limparDespachanteDeAcoesDosModulos = registrarDespachanteDeAcoesDosModulos(
      mensagem => this.despacharAcaoDeModulo(mensagem)
    );
    this.iniciarAssistenteSeNecessario();
  },
  mounted() {
    this.$nextTick(() => this.consumirAberturaDaRota());
  },
  beforeUnmount() {
    this.limparDespachanteDeAcoesDosModulos?.();
    this.limparDespachanteDeAcoesDosModulos = null;
    sincronizarApresentacaoCrisp(false, this.oculto);
    window.removeEventListener("resize", this.verificarLarguraTela);
    window.visualViewport?.removeEventListener("resize", this.atualizarAreaVisual);
    window.visualViewport?.removeEventListener("scroll", this.atualizarAreaVisual);
    this.aberturaEmCurso += 1;
  },
  computed: {
    suporteDisponivel() {
      const ativo = this.$store?.state?.modulosEFuncionalidades?.funcionalidades?.acesso_ferramenta_crisp?.enabled === true;
      return !!this.userInfo && !this.estaEmRotasSemMenu && deveInicializarCrisp(ativo);
    },
    ajudaDoMenu() {
      return criarSecaoAjuda({
        compacto: this.oculto,
        ninaDisponivel: this.deveMontarOAssistente,
        suporteDisponivel: this.suporteDisponivel,
        abrindoSuporte: this.abrindoSuporte,
        t: chave => this.$t(chave),
        abrirNina: () => this.atualizarIntencaoDoAssistente('aberto'),
        abrirSuporte: () => this.abrirSuportePeloMenu(),
      });
    },
    modoDoSuporte() {
      return {
        disponivel: this.suporteDisponivel,
        compacto: this.oculto,
        conversaDaNinaVisivel: ["acoplado", "sobreposto", "recolhido"].includes(this.formaDoAssistente),
      };
    },
    ...mapState(["userInfo"]),
    assistente() {
      return this.$store?.state?.assistentePontotel || {
        messages: [],
        loading: false,
        canvas: { type: "empty" },
      };
    },
    historicoAberto() {
      return this.assistente.historyOpen === true;
    },
    historicoDeConversas() {
      return this.assistente.history || [];
    },
    flagDoAssistente() {
      return this.$store?.state?.modulosEFuncionalidades?.funcionalidades
        ?.assistente_pontotel_habilitado;
    },
    barraAvisoUsuarioSuporteFechada() {
      if (this.fechadaManualmente) {
        return true;
      }
      return obterEstadoFechadoNoStorage(this.userInfo);
    },
    dadosBarraAvisoUsuarioSuporte() {
      return obterDadosBarraAviso({
        nodeEnv: process?.env?.NODE_ENV,
        modoProxy: process?.env?.VUE_APP_MODO_PROXY === "true",
        ambienteAlvoProxy: process?.env?.VUE_APP_AMBIENTE,
        hostname: window?.location?.hostname,
        pathname: window?.location?.pathname,
        href: window?.location?.href,
        userInfo: this.userInfo,
      });
    },
    exibirBarraAvisoUsuarioSuporte() {
      if (this.barraAvisoUsuarioSuporteFechada) {
        return false;
      }
      return this.dadosBarraAvisoUsuarioSuporte.visivel;
    },
    estaNaHome() {
      return this.$route.name === "home";
    },
    exibirBarraTransicao() {
      return this.userInfo?.roleGroup?.kind === 'all' && !this.estaEmRotasSemMenu;
    },
    estaEmRotasSemMenu() {
      return deveSuprimirChromeDoShell(construirContextoDoShell(this.$route, window));
    },
    usaLarguraUtilCompleta() {
      return (
        this.$route.name?.startsWith("controle-de-estacoes") ||
        this.$route.name === "CalendarioAloque"
      );
    },
    deveMontarOAssistente() {
      return deveMontarOAssistente({
        rota: this.$route,
        usuario: this.userInfo,
        flagDoAssistente: this.flagDoAssistente,
        janela: window,
      });
    },
    formaDoAssistente() {
      return formaDoAcoplamento({
        intencao: this.intencaoDoAssistente,
        larguraDaJanela: this.larguraDaJanela,
        montado: this.deveMontarOAssistente,
        resultadoAberto: this.painelAberto,
      });
    },
    janelaEstreita() {
      return this.larguraDaJanela < LARGURA_MINIMA_COM_RESULTADO;
    },
    painelPresente() {
      return this.deveMontarOAssistente && !["empty", "error", "denied"].includes(this.assistente.canvas?.type);
    },
    painelAberto() {
      return this.painelPresente && this.assistente.resultadoVisivel === true;
    },
    classeDoAssistente() {
      return this.deveMontarOAssistente ? `assistente-${this.formaDoAssistente}` : "";
    },
    estiloDaGrade() {
      return {
        "--resultado-altura-visual": `${this.alturaVisual}px`,
        "--shell-altura-transicao": `${this.exibirBarraTransicao ? this.alturaBarraTransicao : 0}px`,
        "--resultado-topo-visual": `${this.topoVisual}px`,
        "--resultado-largura-chat": `${LARGURA_DA_COLUNA_DO_ASSISTENTE}px`,
        "--assistente-largura": this.formaDoAssistente === "acoplado"
          ? `${LARGURA_DA_COLUNA_DO_ASSISTENTE}px`
          : "0px",
      };
    },
    contextoDoAssistente() {
      const usuario = this.userInfo || {};
      const papel = papelDoUsuario(
        usuario.roleGroup?.kind,
        this.$store?.state?.perfilDeAcessoSelecionadoParaMultiPerfis
      );
      // A conversa se apresenta pela tela de onde partiu. O conjunto de telas é
      // fechado: rota fora dele fica sem origem, em vez de exibir o endereço.
      const chaveDaTela = chaveDoNomeDaTela(this.$route?.path);
      return {
        origin: chaveDaTela ? { screen: this.$t(chaveDaTela) } : undefined,
        userId: usuario.id || "usuario-pontotel",
        displayName: usuario.name || "Usuário Pontotel",
        role: papel,
        companyId: usuario.compMan?.id || "empresa-pontotel",
        companyName: usuario.compMan?.name || "Pontotel",
        scope: papel === "empregado" ? { selfOnly: true } : {},
      };
    },
  },
  watch: {
    modoDoSuporte: {
      immediate: true,
      handler(modo) { sincronizarApresentacaoCrisp(modo.disponivel, modo.compacto, modo.conversaDaNinaVisivel); },
    },
    suporteDisponivel: {
      immediate: true,
      // O agente só ganha a ferramenta de suporte onde o Crisp abre: flag da
      // empresa e ambiente, que só o navegador conhece.
      handler(disponivel) { this.$store.commit("assistentePontotel/definirSuporteDisponivel", disponivel); },
    },
    deveMontarOAssistente() {
      this.iniciarAssistenteSeNecessario();
    },
    "$route.fullPath"() {
      this.iniciarAssistenteSeNecessario();
      this.aberturaEmCurso += 1;
      this.dispensarPreenchimentoDaTela();
      this.$nextTick(() => this.consumirAberturaDaRota());
    },
    "assistente.sessionId"() {
      this.aberturaEmCurso += 1;
      this.dispensarPreenchimentoDaTela();
      this.$nextTick(() => this.consumirAberturaDaRota());
    },
    userInfo() {
      this.aberturaEmCurso += 1;
      this.dispensarPreenchimentoDaTela();
    },
    painelAberto(aberto, anterior) {
      if (!aberto) {
        this.anuncioDoResultado = "";
        return;
      }
      if (!aberto || anterior) return;
      this.anunciarResultado(this.assistente.canvas);
      if (!this.origemDoResultado && typeof document !== "undefined") {
        this.origemDoResultado = document.activeElement;
      }
      if (this.intencaoDoAssistente !== "aberto") this.atualizarIntencaoDoAssistente("aberto");
      const ativo = typeof document === "undefined" ? null : document.activeElement;
      const digitandoNoChat = ativo?.closest?.(".assistente-dock") && ativo?.matches?.("input, textarea, [contenteditable='true']");
      this.vistaEstreita = digitandoNoChat ? "conversa" : "resultado";
    },
    "assistente.canvas"(canvas, anterior) {
      if (canvas === anterior || !this.painelAberto) return;
      this.anunciarResultado(canvas);
      if (!this.janelaEstreita) return;
      const ativo = typeof document === "undefined" ? null : document.activeElement;
      const digitandoNoChat = ativo?.closest?.(".assistente-dock") && ativo?.matches?.("input, textarea, [contenteditable='true']");
      this.vistaEstreita = digitandoNoChat ? "conversa" : "resultado";
    },
    janelaEstreita(estreita) {
      if (!this.painelAberto || !estreita) return;
      const ativo = document.activeElement;
      this.vistaEstreita = ativo?.closest?.(".assistente-dock") ? "conversa" : "resultado";
    },
    /*
     * R6 — o Assistente aplicou uma mutação e nomeou a tela dona do dado. Se é
     * a tela que está na frente da pessoa, ela é remontada aqui e volta a
     * buscar; se não é, não há o que fazer — quando a pessoa navegar até lá, o
     * componente monta do zero e já pergunta.
     *
     * Nunca navega, e nunca recarrega o documento: o aviso é para atualizar a
     * tela que a pessoa escolheu ver, não para tirá-la de onde está.
     */
    "assistente.telaParaRevalidar"(tela) {
      if (!tela) return;
      if (telaAbertaFicouVelha(tela, this.$route?.path)) {
        this.revalidarTelaAberta("tela_afetada");
      }
      // A baixa vale nos dois casos: sem ela, o aviso ficaria de pé e cada
      // re-render tentaria remontar a mesma tela de novo.
      this.$store.dispatch("assistentePontotel/telaRevalidada");
    },
    /*
     * O turno da CONVERSA gravou (conversa acbcc000, 08/10/2026: "pode
     * aplicar" lançou a marcação e a folha aberta seguiu velha). Ele não sabe
     * qual tela mostra o dado: só a tela que registrou revalidador é
     * revalidada. As outras NÃO são remontadas — um cadastro meio preenchido
     * voltaria vazio —, e a pessoa é avisada de que a tela pode estar velha.
     */
    "assistente.revalidacoesDaTelaAberta"(atual, anterior) {
      if (!atual || atual === anterior) return;
      this.revalidarTelaAberta("turno_da_conversa");
    },
  },
  methods: {
    /*
     * A tela que sabe se revalidar (Verificar folhas refaz a busca, a Folha
     * reconstrói) faz do jeito dela. Sem revalidador, só o R6 remonta (a
     * régua de rota garantiu que é a tela afetada); o turno da conversa avisa.
     * Nunca navega, nunca recarrega o documento.
     */
    revalidarTelaAberta(origem) {
      const desfecho = decidirRevalidacaoDaTelaAberta(origem, this.revalidacaoDaView);
      this.revalidacaoDaView = desfecho.chaveDaView;
      if (desfecho.avisarTelaDesatualizada) {
        ServicoToast.info(this.$t("assistentePontotel.tela.podeEstarDesatualizada"));
      }
    },
    async abrirSuportePeloMenu() {
      if (!this.suporteDisponivel || this.abrindoSuporte) return;
      this.abrindoSuporte = true;
      try {
        const abriu = await abrirChatCrisp();
        if (!abriu && this.suporteDisponivel) ServicoToast.erro(this.$t('MenuLateral.ajuda.falhaSuporte'));
      } finally {
        this.abrindoSuporte = false;
      }
    },
    async aceitarOfertaDeSuporte({ id, resumo }) {
      const desfecho = await this.$store.dispatch("assistentePontotel/aceitarOfertaDeSuporte", {
        id,
        resumo,
        abrirSuporte: (pedido) => encaminharSaindoDoAssistente({
          // O Crisp não abre com a conversa da Nina à mostra; o watcher de
          // `modoDoSuporte` só libera depois do próximo tick.
          minimizarAssistente: () => this.atualizarIntencaoDoAssistente("minimizado"),
          reabrirAssistente: () => this.atualizarIntencaoDoAssistente("aberto"),
          aguardarRenderizacao: () => this.$nextTick(),
          encaminhar: encaminharAoSuporte,
        }, pedido),
      });
      if (desfecho === "falhou") ServicoToast.erro(this.$t("MenuLateral.ajuda.falhaSuporte"));
    },
    avaliarResposta(avaliacao) {
      // O botão mostra sozinho se o voto não ficou registrado: sem toast aqui.
      return this.$store.dispatch("assistentePontotel/avaliarResposta", avaliacao);
    },
    definirModoDeAcao(escolha) {
      return this.$store.dispatch("assistentePontotel/definirModoDeAcao", escolha);
    },
    executarPlanejamento(pedido) {
      // A recusa aparece no próprio cartão do plano: sem toast aqui.
      return this.$store.dispatch("assistentePontotel/executarPlanejamento", pedido);
    },
    anunciarResultado(canvas) {
      this.anuncioDoResultado = "";
      this.$nextTick(() => {
        if (!this.painelAberto || this.assistente.canvas !== canvas) return;
        const titulo = canvas.title || canvas.spec?.titulo || canvas.charts?.[0]?.spec?.titulo;
        this.anuncioDoResultado = titulo
          ? `${this.$t('assistentePontotel.painelNoContexto.aberto')}: ${titulo}`
          : this.$t('assistentePontotel.painelNoContexto.aberto');
      });
    },
    verificarLarguraTela() {
      const DIMENSAO_MINIMA_MENU_PONTOTEL_DESKTOP = 1024;
      this.larguraDaJanela = window.innerWidth;
      this.atualizarAreaVisual();
      if (window.innerWidth < DIMENSAO_MINIMA_MENU_PONTOTEL_DESKTOP) {
        this.oculto = true;
      } else {
        this.oculto = false;
      }
    },
    atualizarAreaVisual() {
      this.alturaVisual = window.visualViewport?.height ?? window.innerHeight;
      this.topoVisual = window.visualViewport?.offsetTop ?? 0;
    },
    iniciarAssistenteSeNecessario() {
      if (this.assistenteIniciado || !this.deveMontarOAssistente || !this.userInfo) return;
      this.assistenteIniciado = true;
      this.$store.dispatch("assistentePontotel/iniciar", this.contextoDoAssistente);
    },
    atualizarIntencaoDoAssistente(intencao) {
      if (this.painelAberto && intencao !== "aberto") this.voltarATela();
      this.intencaoDoAssistente = intencao;
      persistirIntencaoDoAcoplamento(intencao);
      if (this.oculto && intencao !== 'aberto') this.$nextTick(() => {
        document.querySelector('#menu-lateral button[aria-expanded="false"]')?.focus();
      });
    },
    aoAbrirTela() {
      this.$nextTick(() => this.consumirAberturaDaRota());
    },
    despacharAcaoDeModulo(mensagem) {
      if (!['acoplado', 'sobreposto'].includes(this.formaDoAssistente)) return false;
      if (this.assistente.loading) {
        ServicoToast.info(this.$t('assistentePontotel.progresso.mensagem'));
        return true;
      }
      this.enviarMensagemDoDock(mensagem);
      return true;
    },
    enviarMensagemDoDock(mensagem) {
      // O formulário recolhido emite `send` antes de trocar sua intenção para
      // aberto. Calculamos a forma que estará vigente ao concluir a transição,
      // para que uma navegação pedida nessa primeira pergunta encontre o host
      // na forma em que a pessoa verá a conversa.
      const intencaoAoEnviar = proximaIntencao(this.intencaoDoAssistente, "enviar");
      const formaAoEnviar = formaDoAcoplamento({
        intencao: intencaoAoEnviar,
        larguraDaJanela: this.larguraDaJanela,
        montado: this.deveMontarOAssistente,
        resultadoAberto: this.painelAberto,
      });
      const entrada = typeof mensagem === 'string' ? { texto: mensagem } : mensagem;
      return this.$store.dispatch("assistentePontotel/enviarMensagem", {
        ...entrada,
        formaDoAcoplamento: formaAoEnviar,
        executarNavegacao: (target) => this.executarNavegacaoDoAssistente(target),
        obterRotaAtual: () => this.$route.path,
        rotasSaoEquivalentes: rotasEquivalentesDaFolhaAtual,
        aoAbrirTela: () => this.aoAbrirTela(),
      });
    },
    async executarNavegacaoDoAssistente(target) {
      const destino = await resolverAlvoDaFolhaAtual(this.$API, target, () => new Date());
      return this.$router.push(destino);
    },
    abrirNavegacaoDaMensagem(id) {
      return this.$store.dispatch("assistentePontotel/abrirNavegacaoDaMensagem", {
        id,
        executarNavegacao: (target) => this.executarNavegacaoDoAssistente(target),
        obterRotaAtual: () => this.$route.path,
        rotasSaoEquivalentes: rotasEquivalentesDaFolhaAtual,
        aoAbrirTela: () => this.aoAbrirTela(),
      });
    },
    responderSelecaoDaAntecipacao(escolha) {
      return this.$store.dispatch("assistentePontotel/responderSelecaoDaAntecipacao", {
        ...escolha,
        formaDoAcoplamento: this.formaDoAssistente,
        executarNavegacao: (target) => this.executarNavegacaoDoAssistente(target),
        obterRotaAtual: () => this.$route.path,
        rotasSaoEquivalentes: rotasEquivalentesDaFolhaAtual,
        aoAbrirTela: () => this.aoAbrirTela(),
      });
    },
    responderSolicitacaoDeParametros(resposta) {
      return this.$store.dispatch("assistentePontotel/responderSolicitacaoDeParametros", {
        ...resposta,
        formaDoAcoplamento: this.formaDoAssistente,
        executarNavegacao: (target) => this.executarNavegacaoDoAssistente(target),
        obterRotaAtual: () => this.$route.path,
        rotasSaoEquivalentes: rotasEquivalentesDaFolhaAtual,
        aoAbrirTela: () => this.aoAbrirTela(),
      });
    },
    async consumirAberturaDaRota() {
      if (!this.assistente.sessionId || !this.deveMontarOAssistente) return;
      const contexto = capturarContextoDeAbertura(window.history);
      if (!contexto) return;
      const identificador = ++this.aberturaEmCurso;
      const rota = this.$route.fullPath;
      const identidadeAtual = () => ({
        pessoaId: this.contextoDoAssistente.userId,
        empresaId: this.contextoDoAssistente.companyId,
        sessaoId: this.assistente.sessionId,
      });
      if (!identidadeDaAberturaCompativel(contexto, identidadeAtual())) {
        this.dispensarPreenchimentoDaTela();
        this.falhaDePreenchimento = this.$t("assistentePontotel.tela.preenchimento.falhaConsumo");
        return;
      }
      const ativo = () => identificador === this.aberturaEmCurso &&
        this.$route.fullPath === rota &&
        this.deveMontarOAssistente &&
        identidadeDaAberturaCompativel(contexto, identidadeAtual());
      if (!contexto.rascunhoOpaco) return;
      this.dispensarPreenchimentoDaTela();
      const resultado = await processarContextoDeAbertura(contexto, {
        valida: ativo,
        consumir: (tela, handle) => consumirContextoDeAbertura(tela, handle),
        aplicar: (rascunho, continuaAtivo) => aplicarQuandoRenderizar(
          () => window,
          rascunho,
          {
            ativo: continuaAtivo,
            raiz: this.$el.querySelector("#conteudo-aplicacao"),
          }
        ),
        relatar: (sessaoId, interacaoId, preenchimento) =>
          this.$store.dispatch("assistentePontotel/relatarPreenchimentoDaAbertura", {
            pessoaId: contexto.pessoaId,
            empresaId: contexto.empresaId,
            sessaoId,
            interacaoId,
            resultado: preenchimento,
          }),
      });
      if (!ativo() || resultado.estado === "cancelado") return;
      if (resultado.estado === "aplicado" &&
        (resultado.resultado.aplicados.length || resultado.resultado.recusados.length)) {
        this.preenchimentoDaTela = resultado.resultado;
      } else {
        this.falhaDePreenchimento = this.$t("assistentePontotel.tela.preenchimento.falhaConsumo");
      }
    },
    dispensarPreenchimentoDaTela() {
      this.preenchimentoDaTela = null;
      this.falhaDePreenchimento = null;
    },
    manterPreenchimentoDaTela() {
      manterPreenchimento(window, this.preenchimentoDaTela?.aplicados || [], this.$el.querySelector("#conteudo-aplicacao"));
      this.dispensarPreenchimentoDaTela();
    },
    limparPreenchimentoDaTela() {
      limparPreenchimento(window, this.preenchimentoDaTela?.aplicados || [], this.$el.querySelector("#conteudo-aplicacao"));
      this.dispensarPreenchimentoDaTela();
    },
    gerarPrevia(payload) {
      return this.$store.dispatch("assistentePontotel/gerarPrevia", payload);
    },
    atualizarRascunhoDoFormulario(payload) {
      return this.$store.dispatch("assistentePontotel/atualizarRascunhoDoFormulario", payload);
    },
    abrirResultadoDeTurno(id) {
      this.origemDoResultado = typeof document === "undefined" ? null : document.activeElement;
      this.vistaEstreita = "resultado";
      return this.$store.dispatch("assistentePontotel/abrirResultadoDeTurno", id).then(() => {
        this.$nextTick(() => this.$refs.painelDoResultado?.querySelector?.(".canvas")?.focus?.());
      });
    },
    escolherVistaEstreita(vista) {
      this.vistaEstreita = vista;
    },
    alternarAbaPeloTeclado() {
      this.vistaEstreita = this.vistaEstreita === "resultado" ? "conversa" : "resultado";
      this.$nextTick(() => this.$el.querySelector(`#aba-${this.vistaEstreita}`)?.focus());
    },
    voltarATela() {
      const compacta = this.janelaEstreita;
      this.$store.dispatch("assistentePontotel/ocultarResultado");
      if (compacta) {
        this.intencaoDoAssistente = "minimizado";
        persistirIntencaoDoAcoplamento("minimizado");
      }
      const origem = this.origemDoResultado;
      this.origemDoResultado = null;
      this.$nextTick(() => {
        const origemVisivel = origem?.isConnected && origem.getClientRects?.().length &&
          origem.matches?.("button, input, textarea, select, a[href], [tabindex], [contenteditable='true']") &&
          !origem.matches?.(":disabled") && !origem.closest?.("[inert]") && getComputedStyle(origem).visibility !== "hidden";
        const destino = origemVisivel ? origem : this.$el.querySelector(compacta
          ? "[data-testid='assistente-dock-acionador']"
          : ".composer textarea");
        destino?.focus?.({ preventScroll: true });
      });
    },
    confirmarPrevia(preview) {
      return this.$store.dispatch("assistentePontotel/confirmarPrevia", preview);
    },
    prosseguirDestrutiva() {
      return this.$store.dispatch("assistentePontotel/prosseguirComAcaoDestrutiva");
    },
    refazerPrevia() {
      return this.$store.dispatch("assistentePontotel/refazerPrevia");
    },
    reconciliar() {
      return this.$store.dispatch("assistentePontotel/reconciliarResultado");
    },
    pedirNovaConversa() {
      // Sem pergunta da pessoa não há o que perder: reiniciar direto poupa um
      // diálogo que só teria a saudação para descartar. A regra canônica é
      // `precisaConfirmarNovaConversa` (apresentacao/state.ts), não importada
      // aqui pelo mesmo motivo do gate de navegação: o App é módulo de boot.
      const temPerguntaDaPessoa = (this.assistente.messages || []).some(
        (mensagem) => mensagem.role === "user"
      );
      if (!temPerguntaDaPessoa) {
        this.aberturaEmCurso += 1;
        this.dispensarPreenchimentoDaTela();
        return this.$store.dispatch("assistentePontotel/iniciarNovaConversa");
      }
      this.confirmacaoDeNovaConversa = true;
    },
    cancelarNovaConversa() {
      this.confirmacaoDeNovaConversa = false;
    },
    confirmarNovaConversa() {
      this.confirmacaoDeNovaConversa = false;
      this.aberturaEmCurso += 1;
      this.dispensarPreenchimentoDaTela();
      return this.$store.dispatch("assistentePontotel/iniciarNovaConversa");
    },
    abrirPoliticasDeIa() {
      // Mesma aba do resultado em que as tabelas aparecem: `definirCanvas`
      // torna o painel visível e a janela estreita troca para a aba "Resultado".
      this.$store.commit("assistentePontotel/definirCanvas", {
        type: "politicas",
        title: this.$t("assistentePontotel.politicasDeIa.titulo"),
        // Quem pediu uma política à Nina e volta ao livro espera ver a nova na lista.
        abertoEm: Date.now(),
      });
    },
    abrirHistorico() {
      // Quem abriu um diálogo modal espera voltar de onde saiu. Sem guardar a
      // origem, fechar joga o foco no body e a navegação por teclado recomeça
      // do topo do app — medido antes desta linha.
      this.origemDoHistorico =
        typeof document === "undefined" ? null : document.activeElement;
      this.$store.commit("assistentePontotel/definirHistoricoAberto", true);
    },
    fecharHistorico() {
      this.$store.commit("assistentePontotel/definirHistoricoAberto", false);
      const origem = this.origemDoHistorico;
      this.origemDoHistorico = null;
      // A gaveta é teleportada e sai do DOM ao fechar; devolver o foco antes
      // disso seria roubá-lo de volta na mesma tarefa.
      this.$nextTick(() => {
        if (origem && typeof origem.focus === "function" && origem.isConnected) {
          origem.focus();
        }
      });
    },
    reabrirHistorico(item) {
      return this.$store.dispatch("assistentePontotel/reabrirHistorico", item);
    },
    fecharBarraAvisoUsuarioSuporte() {
      this.fechadaManualmente = true;
      salvarEstadoFechadoNoStorage(this.userInfo);
    },
  },
  components: {
    BarraAvisoUsuarioSuporte,
    BarraTransicaoDeEscalas,
    MenuLateral,
    AssistenteDock,
    BarraDePreenchimento: defineAsyncComponent(() =>
      import("@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/BarraDePreenchimento.vue")
    ),
    /*
     * Carregamento tardio de propósito. `main.ts` importa este App na linha 2,
     * antes do store (linha 4); a gaveta puxa o cliente HTTP, que puxa o
     * store, e um import estático faria o store avaliar de dentro do ciclo de
     * boot — a mesma armadilha que derrubou o app na rodada 1.
     */
    HistoryDrawer: defineAsyncComponent(() =>
      import(
        "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/historico/HistoryDrawer.vue"
      )
    ),
    ConfirmacaoDeNovaConversa: defineAsyncComponent(() =>
      import(
        "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/acoplamento/ConfirmacaoDeNovaConversa.vue"
      )
    ),
    CanvasPane: defineAsyncComponent(() =>
      import(
        "@/typescript/modulos/governanca/AssistentePontotel/apresentacao/canvas/CanvasPane.vue"
      )
    ),
    PToaster,
  },
};
</script>

<style lang="scss">
@use "../static/css/_variaveis.scss" as Constantes;
body {
  margin: 0;
  padding: 0;
  height: 100%;
  max-height: 100%;
}

html {
  width: 100%;
  height: 100%;
  max-height: 100%;
  background-color: var(--front-background-color);
}

* {
  box-sizing: border-box;
}
#container-externo, #app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  line-height: 1.42857143;
  color: #333;
  background-color: var(--front-background-color);
  width: 100vw;
  max-width: 100vw;
  height: 100%;
  min-height: 100vh;
  display: grid;
  --assistente-largura: 0px;
  --shell-altura-aviso-usuario-suporte: var(--espacamento-0);
  --shell-altura-transicao: var(--espacamento-0);
  --shell-recuo-superior: calc(var(--shell-altura-aviso-usuario-suporte) + var(--shell-altura-transicao));
  padding-top: var(--shell-recuo-superior);
  grid-template-columns: Constantes.$largura-menu-pontotel minmax(0, 1fr) var(--assistente-largura);
  grid-template-areas: "menu-pontotel view assistente";
  overflow-x: hidden;

  &.sem-menu {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: 1fr;
    grid-template-areas: "view";
  }

  &.com-barra-aviso-usuario-suporte {
    --shell-altura-aviso-usuario-suporte: var(--espacamento-36);
  }

  &.com-barra-aviso-usuario-suporte,
  &.com-barra-transicao {
    .pontotel-menu-vertical {
      top: var(--shell-recuo-superior) !important;
      height: calc(100vh - var(--shell-recuo-superior)) !important;
      height: calc(100dvh - var(--shell-recuo-superior)) !important;
    }

    .pontotel-menu-vertical__cabecalho-compacto {
      top: var(--shell-recuo-superior) !important;
    }

    .pontotel-menu-gaveta {
      top: var(--shell-recuo-superior) !important;
      height: calc(100vh - var(--shell-recuo-superior)) !important;
      height: calc(100dvh - var(--shell-recuo-superior)) !important;
    }
  }

  @media screen and (max-width: 1023px) {
    grid-template-columns: 1fr;
    grid-template-rows: Constantes.$altura-menu-pontotel-mobile 1fr;
    grid-template-areas:
    "menu-pontotel"
    "view";

    &.sem-menu {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      grid-template-areas: "view";
    }
  }
}

/* Abrir o painel empurra a tela; o empurrão é um movimento, não um corte de
 * 370px. Quem pediu menos animação no sistema não recebe nenhum. */
#container-externo {
  --resultado-recuo-lateral: var(--espacamento-44);
  transition: grid-template-columns .22s ease;
}

@media (max-width: 1023px) {
  #container-externo {
    --resultado-recuo-lateral: var(--espacamento-0);
  }
}

@media (prefers-reduced-motion: reduce) {
  #container-externo {
    transition: none;
  }
}

/* Reserva espaço acima do suporte somente enquanto ele estiver visível. */
#container-externo .assistente-dock--minimizado {
  position: fixed;
  right: var(--espacamento-24);
  bottom: calc(var(--espacamento-24) + var(--assistente-recuo-suporte));
  z-index: 1000000;
}

/* O painel é uma coluna da grade do shell, então crescia junto com o
 * documento: em telas longas o composer ficava 1077px abaixo, alcançável só
 * rolando a página inteira. Preso ao topo, ele acompanha a leitura.
 *
 * Mora aqui, e não no escopo do dock, porque é este seletor com id que vence
 * por especificidade — a regra de lá seria ignorada. */
#container-externo .assistente-dock--acoplado {
  position: sticky;
  top: var(--espacamento-0);
  height: calc(100dvh - var(--shell-recuo-superior));
  max-height: calc(100dvh - var(--shell-recuo-superior));
  align-self: start;
}

.resultado-contexto__fundo {
  position: fixed;
  inset: 0 var(--resultado-largura-chat) 0 0;
  z-index: 999998;
  padding: 0;
  border: 0;
  border-radius: 0;
  /* O Imaginii publica a cor, mas não a opacidade do fundo do protótipo. */
  background: color-mix(in srgb, var(--cor-neutra-500) 32%, transparent);
  cursor: pointer;
  touch-action: none;
}

#container-externo.resultado-aberto #menu-lateral,
#container-externo.resultado-aberto #conteudo-aplicacao {
  isolation: isolate;
  z-index: 0;
}

.resultado-contexto {
  position: fixed;
  top: 0;
  right: var(--resultado-largura-chat);
  z-index: 999999;
  width: min(960px, calc(100vw - var(--resultado-largura-chat) - var(--espacamento-64) - var(--espacamento-80)));
  min-width: 0;
  height: 100dvh;
  overflow: hidden;
  overscroll-behavior: contain;
  background: var(--cor-background-fundo-principal);
}

#container-externo.resultado-aberto .assistente-dock--acoplado {
  position: fixed;
  top: var(--shell-recuo-superior);
  right: 0;
  z-index: 1000000;
  width: var(--resultado-largura-chat);
}

.resultado-contexto:focus { outline: none; }
.resultado-contexto:focus-visible { outline: var(--espessura-20) solid var(--cor-secundaria-100); outline-offset: calc(var(--espacamento-2) * -1); }

.resultado-contexto__abas {
  height: var(--espacamento-48);
  display: flex;
  font-family: var(--texto-tipografia);
  background: var(--cor-background-fundo-principal);
  border-bottom: var(--espessura-10) solid var(--cor-neutra-40);
}

.resultado-contexto__abas button {
  flex: 1;
  padding: var(--espacamento-12);
  border: 0;
  color: var(--cor-texto-principal);
  background: transparent;
  font: inherit;
  cursor: pointer;
}

.resultado-contexto__abas button[aria-selected="true"] {
  border-bottom: var(--espessura-20) solid var(--cor-secundaria-100);
}

.resultado-contexto__abas button:focus-visible {
  outline: var(--espessura-20) solid var(--cor-secundaria-100);
  outline-offset: calc(var(--espacamento-2) * -1);
}

.resultado-contexto__anuncio {
  position: absolute;
  width: var(--espacamento-1);
  height: var(--espacamento-1);
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

#container-externo.resultado-estreito .resultado-contexto__fundo {
  right: 0;
}

#container-externo.resultado-estreito .resultado-contexto,
#container-externo.resultado-estreito .assistente-dock--sobreposto {
  position: fixed;
  top: var(--resultado-topo-visual);
  right: 0;
  bottom: auto;
  left: var(--resultado-recuo-lateral);
  width: calc(100% - var(--resultado-recuo-lateral));
  height: var(--resultado-altura-visual);
  max-height: var(--resultado-altura-visual);
}

#container-externo.resultado-estreito .resultado-contexto {
  top: calc(var(--resultado-topo-visual) + var(--espacamento-44) + var(--espacamento-48));
  height: calc(var(--resultado-altura-visual) - var(--espacamento-44) - var(--espacamento-48));
  max-height: calc(var(--resultado-altura-visual) - var(--espacamento-44) - var(--espacamento-48));
}

#container-externo.resultado-em-foco .assistente-dock--sobreposto {
  background: transparent;
  box-shadow: none;
  pointer-events: none;
}

#container-externo.resultado-em-foco .assistente-dock__cabecalho,
#container-externo.resultado-em-foco .resultado-contexto__abas {
  pointer-events: auto;
}

#menu-lateral {
  grid-area: menu-pontotel;
}

#conteudo-aplicacao {
  grid-area: view;
  padding: 1rem 1rem;
  width: 100%;
  height: 100%;
  min-width: 0;
  margin-inline: auto;
  container-name: aplicacao;
  container-type: inline-size;
}

@media screen and (min-width: 1025px) {
  #container-externo.assistente-minimizado #conteudo-aplicacao:not(.conteudo-aplicacao--full) {
    padding-inline-end: calc(var(--espacamento-16) + var(--espacamento-80));
  }
}

#conteudo-aplicacao.conteudo-aplicacao--full {
  padding: 0;
  margin-inline: 0;
}

/* Tela Inicial: fundo cinza contínuo na área de conteúdo (cobre o padding do
   #conteudo-aplicacao e o gutter direito do grid) — evita os "2 tons" de cinza. */
#container-externo.fundo-home {
  background-color: var(--superficie-app);
}
</style>
